<template>
    <div>
        <el-select v-model="radio" placeholder="请选择活动区域" style="width:750px;">
            <el-breadcrumb separator=">" style="margin:10px 0 0 10px;">
                <el-breadcrumb-item class="word_font">扣分项</el-breadcrumb-item>
                <el-breadcrumb-item class="word_font">拼写错误</el-breadcrumb-item>
                <el-breadcrumb-item>
                    <el-option class="option_style" :value="radio">
                        <el-radio v-for="(val,n) in deductMarks[0].children" :key="n" v-model="radio" :label="val.label" style="margin: 5px;"></el-radio>
                    </el-option>
                </el-breadcrumb-item>
            </el-breadcrumb>
            <el-breadcrumb separator=">"  v-for="(item,i) in deductMarks.slice(1)" :key="i" style="margin-left:83px;">
                <el-breadcrumb-item class="word_font">{{item.label}}</el-breadcrumb-item>
                <el-breadcrumb-item style="font-size:16px;">
                    <el-option class="option_style" style="height:80px;padding-left:10px;" :value="radio">
                        <el-radio v-for="(val,n) in item.children" :key="n" v-model="radio" :label="val.label" style="margin: 5px;"></el-radio>
                    </el-option>
                </el-breadcrumb-item>
            </el-breadcrumb>
            <el-breadcrumb separator=">">
                <el-breadcrumb-item class="word_font" style="margin-left:10px;">加分项</el-breadcrumb-item>
                <el-breadcrumb-item style="font-size:16px;">
                    <el-option class="option_style" style="height:80px;" :value="radio">
                        <el-radio v-for="(item,i) in options" :key="i" v-model="radio" :label="item.label" :value="item.value" style="margin:5px;"></el-radio>
                    </el-option>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </el-select>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                radio: '',
                options: [
                    {
                        value: '高级词汇',
                        label: '高级词汇'
                    }, 
                    {
                        value: '同义表达多样',
                        label: '同义表达多样'
                    }, 
                    {
                        value: '表达地道',
                        label: '表达地道'
                    }, 
                    {
                        value: '句式多样正确',
                        label: '句式多样正确'
                    }, 
                    {
                        value: '名言使用恰当',
                        label: '名言使用恰当'
                    }, 
                    {
                        value: '衔接流畅',
                        label: '衔接流畅'
                    }, 
                    {
                        value: '篇章结构清晰',
                        label: '篇章结构清晰'
                    }, 
                    {
                        value: '论点新颖',
                        label: '论点新颖'
                    }, 
                    {
                        value: '紧扣主题',
                        label: '紧扣主题'
                    }
                ],
                deductMarks:[
                    {
                        value: '拼写错误',
                        label: '拼写错误',
                        children: [
                            {
                                value: '大小写错误',
                                label: '大小写错误'
                            }, 
                            {
                                value: '缩写错误',
                                label: '缩写错误'
                            }, 
                            {
                                value: '没有此词',
                                label: '没有此词'
                            }, 
                            {
                                value: '拼写错误',
                                label: '拼写错误'
                            }, 
                            {
                                value: '复合词拼写错误',
                                label: '复合词拼写错误'
                            }
                        ]
                    },
                    {
                        value: '语法错误',
                        label: '语法错误',
                        children: [
                            {
                                value: '搭配错误',
                                label: '搭配错误'
                            }, 
                            {
                                value: '并列结构错误',
                                label: '并列结构错误'
                            }, 
                            {
                                value: '连词错误',
                                label: '连词错误'
                            }, 
                            {
                                value: '限定词错误',
                                label: '限定词错误'
                            }, 
                            {
                                value: '数词错误',
                                label: '数词错误'
                            }, 
                            {
                                value: '代词错误',
                                label: '代词错误'
                            }, 
                            {
                                value: '介词错误',
                                label: '介词错误'
                            }, 
                            {
                                value: '冠词错误',
                                label: '冠词错误'
                            }, 
                            {
                                value: '单复数错误',
                                label: '单复数错误'
                            }, 
                            {
                                value: '主谓不一致',
                                label: '主谓不一致'
                            }, 
                            {
                                value: '时态错误',
                                label: '时态错误'
                            }, 
                            {
                                value: '动词形式错误',
                                label: '动词形式错误'
                            }, 
                            {
                                value: '语态错误',
                                label: '语态错误'
                            }, 
                            {
                                value: '比较级使用错误',
                                label: '比较级使用错误'
                            }, 
                            {
                                value: '复合句结构错误',
                                label: '复合句结构错误'
                            }
                        ]
                    }, 
                    {
                        value: '语义错误',
                        label: '语义错误',
                        children: [
                            {
                                value: '措辞错误',
                                label: '措辞错误'
                            },
                            {
                                value: '意义不明',
                                label: '意义不明'
                            },
                            {
                                value: '褒贬错误',
                                label: '褒贬错误'
                            },
                            {
                                value: '歧义',
                                label: '歧义'
                            }
                        ]
                    }, 
                    {
                        value: '语用错误',
                        label: '语用错误',
                        children: [
                            {
                                value: '中式英语',
                                label: '中式英语'
                            },
                            {
                                value: '文化差异',
                                label: '文化差异'
                            },
                            {
                                value: '口语化',
                                label: '口语化'
                            }
                        ]
                    }, 
                    {
                        value: '结构错误',
                        label: '结构错误',
                        children: [
                            {
                                value: '逻辑错误',
                                label: '逻辑错误'
                            }, 
                            {
                                value: '标点错误',
                                label: '标点错误'
                            }, 
                            {
                                value: '断句错误',
                                label: '断句错误'
                            }, 
                            {
                                value: '不完整句',
                                label: '不完整句'
                            }, 
                            {
                                value: '词序错误',
                                label: '词序错误'
                            }, 
                            {
                                value: '语句不通顺',
                                label: '语句不通顺'
                            }, 
                            {
                                value: '语序调换',
                                label: '语序调换'
                            }, 
                            {
                                value: '修饰语位置错误',
                                label: '修饰语位置错误'
                            }
                        ]
                    }, 
                    {
                        value: '内容错误',
                        label: '内容错误',
                        children: [
                            {
                                value: '内容重复',
                                label: '内容重复'
                            }, 
                            {
                                value: '内容不相关',
                                label: '内容不相关'
                            }, 
                            {
                                value: '要点缺失',
                                label: '要点缺失'
                            }
                        ]
                    }
                ] 
            };
        },
        methods: {
            // 验证下拉框是否有值
            handleCheck(){
                console.log(12345,this.radio)
            }
        }
    };
</script>
<style scoped>
    .word_font {
        font-size:16px;font-weight:bolder;
    }
    .option_style {
        display: flex;flex-wrap:wrap;width:546px;
    }
</style>
<style>
    .el-radio__input{
        display: none;
    }
    .el-select-dropdown__wrap {
        max-height: 600px;
    }
</style>